import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, withCtx as _withCtx, resolveComponent as _resolveComponent } from "vue"

import { ref } from "vue";
import { orgApiStore, orgStore, permissionStore, saveOrgStore } from "@/hooks";
import { Modal, TextButton } from "@/components/common";
import { SaveOrganizationInputs } from "@/components/organization/save";


/**
 * Displays an organization's actions.
 */
const __default__ = {
  name: "OrganizationSelector",
};

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  setup(__props) {

const createOpen = ref(false);

/**
 * Opens or closes the organization creator modal.
 */
function handleCreate(open?: boolean) {
  createOpen.value = open || false;
  saveOrgStore.resetOrg();
}

return (_ctx: any,_cache: any) => {
  const _component_q_select = _resolveComponent("q-select")!

  return (_openBlock(), _createBlock(_component_q_select, {
    modelValue: _unref(orgApiStore).currentOrg,
    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_unref(orgApiStore).currentOrg) = $event)),
    standout: "",
    "bg-color": "transparent",
    class: "nav-breadcrumb",
    label: "Organization",
    options: _unref(orgStore).allOrgs,
    "option-value": "id",
    "option-label": "name"
  }, {
    "after-options": _withCtx(() => [
      (_unref(permissionStore).isAllowed('safa.create_orgs'))
        ? (_openBlock(), _createBlock(_unref(TextButton), {
            key: 0,
            text: "",
            color: "primary",
            icon: "add",
            label: "Add Organization",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (handleCreate(true)))
          }))
        : _createCommentVNode("", true),
      _createVNode(_unref(Modal), {
        size: "sm",
        title: "Create Organization",
        open: createOpen.value,
        onClose: _cache[1] || (_cache[1] = ($event: any) => (handleCreate(false)))
      }, {
        default: _withCtx(() => [
          _createVNode(_unref(SaveOrganizationInputs))
        ]),
        _: 1
      }, 8, ["open"])
    ]),
    _: 1
  }, 8, ["modelValue", "options"]))
}
}

})